import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import './Profile.css';

const Profile: React.FC = () => {
  const { user } = useSelector((state: RootState) => state.auth);

  const fullName = user ? `${user.firstName} ${user.lastName}` : 'Guest User';
  const emailVal = user ? user.email : 'keshav.singh@gmail.com';
  const phoneVal = user ? user.phone : '+91-9667722651';
  const companyVal = user ? user.companyName : 'Apex B2B Solutions';

  return (
    <div className="account-profile-page">
      <div className="account-profile-container">
        
        <div className="account-layout">
          
          {/* Sidebar */}
          <aside className="account-sidebar-panel">
            <div className="account-user-header">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="user-icon">
                <path d="M20 21a8 8 0 0 0-16 0"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
              {fullName}
            </div>
            <nav className="account-nav-list">
              <Link to="/account/addresses" className="account-nav-item active">
                <span className="icon green-icon">⌖</span> My Addresses
              </Link>
              <Link to="/account/rfqs" className="account-nav-item">
                <span className="icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></span> My RFQ's
              </Link>
              <Link to="/account/orders" className="account-nav-item">
                <span className="icon">▣</span> My Order
              </Link>
              <Link to="/account/business" className="account-nav-item">
                <span className="icon">▤</span> My Business Details
              </Link>
              <Link to="/account/wishlist" className="account-nav-item">
                <span className="icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></span> My Wishlist
              </Link>
              <Link to="/logout" className="account-nav-item">
                <span className="icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg></span> Log-out
              </Link>
            </nav>
          </aside>

          {/* Main Content */}
          <main className="account-main-content">
            
            <div className="profile-sections-wrapper">
              
              {/* MY PROFILE SECTION */}
              <section className="profile-form-section">
                <h2 className="section-title">MY PROFILE</h2>
                <div className="profile-form-container">
                  <div className="form-group-with-btn">
                    <div className="form-group">
                      <label>Full Name</label>
                      <input type="text" defaultValue={fullName} />
                    </div>
                    <button className="btn-edit-small">EDIT NAME</button>
                  </div>
                  <div className="form-group-with-btn">
                    <div className="form-group">
                      <label>Email</label>
                      <input type="email" defaultValue={emailVal} />
                    </div>
                    <button className="btn-edit-small">EDIT EMAIL</button>
                  </div>
                  <div className="form-group-with-btn">
                    <div className="form-group">
                      <label>Phone Number</label>
                      <input type="text" defaultValue={phoneVal} />
                    </div>
                    <button className="btn-edit-small">EDIT PHONE NUMBER</button>
                  </div>
                </div>
              </section>

              {/* ADD SHIPPING ADDRESS SECTION */}
              <section className="profile-form-section">
                <h2 className="section-title">ADD SHIPPING ADDRESS</h2>
                <div className="profile-form-container">
                  <div className="form-row-split">
                    <div className="form-group">
                      <label>Full Name*</label>
                      <input type="text" defaultValue={fullName} />
                    </div>
                    <div className="form-group">
                      <label>Email*</label>
                      <input type="email" defaultValue={emailVal} />
                    </div>
                  </div>
                  <div className="form-row-split">
                    <div className="form-group">
                      <label>Phone Number*</label>
                      <input type="text" defaultValue={phoneVal} />
                    </div>
                    <div className="form-group">
                      <label>Enter Alternate Phone Number</label>
                      <input type="text" defaultValue="" placeholder="e.g. +91 99999 88888" />
                    </div>
                  </div>
                  <div className="form-row-split">
                    <div className="form-group">
                      <label>Flat, House Number, Building, Office*</label>
                      <input type="text" defaultValue="" placeholder="e.g. Flat No. 504, Sector 15" />
                    </div>
                    <div className="form-group">
                      <label>Area, Street, Sector, Village*</label>
                      <div className="select-wrapper">
                        <select defaultValue="area1">
                          <option value="area1">Area 1 / Main Sector</option>
                        </select>
                        <span className="select-arrow">▼</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row-split">
                    <div className="form-group">
                      <label>Pin code*</label>
                      <input type="text" defaultValue="11024" />
                    </div>
                    <div className="form-group">
                      <label>Land Mark*</label>
                      <div className="select-wrapper">
                        <select defaultValue="lm1">
                          <option value="lm1">Landmark 1</option>
                        </select>
                        <span className="select-arrow">▼</span>
                      </div>
                    </div>
                  </div>
                  <div className="form-row-split">
                    <div className="form-group">
                      <label>State*</label>
                      <div className="select-wrapper">
                        <select defaultValue="Delhi">
                          <option value="Delhi">Delhi</option>
                        </select>
                        <span className="select-arrow">▼</span>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>City/District/Town*</label>
                      <input type="text" defaultValue="New Delhi" />
                    </div>
                  </div>
                  <div className="form-row-split">
                    <div className="form-group half-width">
                      <label>Country*</label>
                      <input type="text" defaultValue="India" />
                    </div>
                  </div>
                  <div className="form-actions-row">
                    <button type="button" className="btn-cancel">CANCEL</button>
                    <button type="button" className="btn-save">SAVE CHANGES</button>
                  </div>
                </div>
              </section>

              {/* ADD BILLING ADDRESS SECTION */}
              <section className="profile-form-section">
                <h2 className="section-title">ADD BILLING ADDRESS</h2>
                <div className="profile-form-container">
                  <div className="form-row-split">
                    <div className="form-group">
                      <label>Enter GST Number*</label>
                      <input type="text" defaultValue="07AAAAA1111A1Z1" />
                    </div>
                    <div className="form-group">
                      <label>Business Name*</label>
                      <input type="text" defaultValue={companyVal} />
                    </div>
                  </div>
                  <div className="form-row-split">
                    <div className="form-group">
                      <label>Business Phone*</label>
                      <input type="text" defaultValue={phoneVal} />
                    </div>
                    <div className="form-group">
                      <label>Business Email ID (Optional)</label>
                      <input type="email" defaultValue={emailVal} />
                    </div>
                  </div>
                  <div className="form-group full-width">
                    <label>Address</label>
                    <input type="text" defaultValue="Road No. 13/x, Industrial Area Phase 2" />
                  </div>
                  <div className="form-row-split">
                    <div className="form-group">
                      <label>Pin code*</label>
                      <input type="text" defaultValue="11024" />
                    </div>
                    <div className="form-group">
                      <label>City/District/Town*</label>
                      <input type="text" defaultValue="New Delhi" />
                    </div>
                  </div>
                  <div className="form-row-split">
                    <div className="form-group">
                      <label>State*</label>
                      <div className="select-wrapper">
                        <select defaultValue="Delhi">
                          <option value="Delhi">Delhi</option>
                        </select>
                        <span className="select-arrow">▼</span>
                      </div>
                    </div>
                    <div className="form-group">
                      <label>Country*</label>
                      <input type="text" defaultValue="India" />
                    </div>
                  </div>
                  <div className="form-actions-row">
                    <button type="button" className="btn-cancel">CANCEL</button>
                    <button type="button" className="btn-save">SAVE CHANGES</button>
                  </div>
                </div>
              </section>

              {/* CHANGE PASSWORD SECTION */}
              <section className="profile-form-section">
                <h2 className="section-title">CHANGE PASSWORD</h2>
                <div className="profile-form-container">
                  <div className="form-group full-width password-input">
                    <label>Current Password</label>
                    <div className="input-with-icon">
                      <input type="password" placeholder="8+ characters" />
                      <span className="eye-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></span>
                    </div>
                  </div>
                  <div className="form-group full-width password-input">
                    <label>New Password</label>
                    <div className="input-with-icon">
                      <input type="password" placeholder="8+ characters" />
                      <span className="eye-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></span>
                    </div>
                  </div>
                  <div className="form-group full-width password-input">
                    <label>Confirm Password</label>
                    <div className="input-with-icon">
                      <input type="password" placeholder="8+ characters" />
                      <span className="eye-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></span>
                    </div>
                  </div>
                  <div className="form-actions-row">
                    <button type="button" className="btn-save">CHANGE PASSWORD</button>
                  </div>
                </div>
              </section>

            </div>

          </main>
        </div>
      </div>
    </div>
  );
};

export default Profile;
